// src/pages/CreatorPerformancePage.jsx
import React from 'react';
import UserLayout from '../components/UserLayout'; // Import the UserLayout component


const BackendMetrices = () => {
  return (
    <UserLayout>
      
    </UserLayout>
  );
};

export default BackendMetrices;